import { useEffect } from "react";
import { BookOpen, HelpCircle, Keyboard, Mail, X } from "lucide-react";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

const TOPICS = [
  { title: "Dashboard & Needs you", text: "The Needs you panel lists only what is waiting on you, with live counts. Each row opens the filtered list.", to: "/dashboard" },
  { title: "Staffing board", text: "Open positions, recruiters, priorities and fill history. Recruiters can be any active recruiter, staffing coordinator or operations user.", to: "/master-staffing-board" },
  { title: "Credentials", text: "Licenses and clearances live on the Credentials page. Provider profiles, assignment readiness and client badges all read the same records.", to: "/credential-intelligence" },
  { title: "Evaluation pipeline", text: "Requests, consent, scheduling, reports and billing. Admins can correct the completed-on date with a required note.", to: "/evaluation-pipeline" },
  { title: "Supervision verification", text: "Monthly logs, confirmations, attestations and release for supervision pay (open month due the 2nd, released by the 4th, paid the 7th).", to: "/supervision-verification" },
  { title: "Connecteam", text: "Read-only sync of users, shifts and time entries; time exceptions and CEO approvals are resolved here.", to: "/connecteam" },
];

export const HelpPanel = ({ open, onClose }) => {
  const { user } = useAuth();
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (event) => { if (event.key === "Escape") onClose(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);
  if (!open) return null;
  const topics = user?.role === "client" ? TOPICS.filter((t) => t.title.startsWith("Evaluation")) : TOPICS;
  return (
    <div className="help-backdrop" data-testid="help-backdrop" onClick={onClose}>
      <aside className="help-panel" data-testid="help-panel" role="dialog" aria-label="Help center" onClick={(event) => event.stopPropagation()}>
        <header className="help-head">
          <HelpCircle size={18} />
          <div><p className="eyebrow">HELP CENTER</p><h2>How TAGForce works</h2></div>
          <button type="button" className="icon-button" aria-label="Close help" data-testid="help-close" onClick={onClose}><X size={18} /></button>
        </header>
        <section className="help-section">
          <h3><Keyboard size={14} /> Shortcuts</h3>
          <ul className="help-shortcuts">
            <li><kbd>⌘ K</kbd> or <kbd>Ctrl K</kbd> focus search · results group by clients, providers, assignments and evaluations · <kbd>Enter</kbd> opens the first result</li>
            <li><kbd>Esc</kbd> closes panels and drawers</li>
          </ul>
        </section>
        <section className="help-section">
          <h3><BookOpen size={14} /> Where things live</h3>
          <ul className="help-topics">
            {topics.map((topic) => (
              <li key={topic.title}><Link to={topic.to} onClick={onClose} data-testid={`help-topic-${topic.to.replace(/\//g, "")}`}><strong>{topic.title}</strong><span>{topic.text}</span></Link></li>
            ))}
          </ul>
        </section>
        <section className="help-section">
          <h3><Mail size={14} /> Need a person?</h3>
          <p>All dates and deadlines in TAGForce are Eastern Time. For account or data questions email <a href="mailto:lesley@theallicockgroup.com" data-testid="help-contact">lesley@theallicockgroup.com</a>.</p>
        </section>
      </aside>
    </div>
  );
};
